import React, { useContext } from 'react';
import styles from './YouTubeChannel.module.css';
import { LanguageContext } from '../LanguageContext/LanguageContext';
import { assests } from '../../assets/assests';

const YouTubeChannel = ({ thirdData }) => {
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === 'rtl';

  if (!thirdData) return <p>Loading...</p>; // Handle loading state

  // Use thirdData for title and mediaContent
  const title = isRTL ? thirdData.titleInArab : thirdData.titleInEng;
  const mediaContent = thirdData.mediaContent || [];

  return (
    <div className={styles.bgcontainer}>
      <h1>{title}</h1>

      <div className={styles.CardContainer}>
        {mediaContent.map((content, index) => {
          // Convert the YouTube link to an embedded URL
          const videoId = new URL(content.instagramLink).searchParams.get('v');
          const embedUrl = `https://www.youtube.com/embed/${videoId}`;

          return (
            <div key={index} className={styles.card}>
              <iframe
                className={styles.video}
                src={embedUrl}
                title={`YouTube video ${index + 1}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <div className={styles.imagagelogo}>
                <div>
                  <img 
                    src={content.imageUrl} 
                    alt="Channel Logo" 
                    className={styles.logoImage} 
                  />
                </div>
                <div>
                  <h5>{isRTL ? content.description : content.other}</h5>
                  <div className={styles.titless}>
                  <a style={{display:"flex", flexDirection:"row", textDecoration:"none" , gap:"10px"}} href={embedUrl} target="_blank" rel="noopener noreferrer">
                    <p>{isRTL ? "المزيد من الحلقات" : "More"}</p> {/* Hardcoded text based on language */}
           
                      <img 
                        src={assests.youtubeicon} 
                        alt="YouTube Icon" 
                        className={styles.iconImage} 
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YouTubeChannel;
